import React, { ComponentProps } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import { MarkdownProps } from './Markdown';

import { PaddedOl, PaddedUl } from './components';

const defaultLinkRenderer: Components['a'] = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

const defaultComponents: MarkdownProps['components'] = {
  ol: ({ node, ...props }) => {
    return <PaddedOl {...props} />;
  },
  ul: ({ node, ...props }) => {
    return <PaddedUl {...props} />;
  },
  a: defaultLinkRenderer,
};

export const MarkdownTargetBlank = ({ components, ...others }: ComponentProps<typeof ReactMarkdown>): JSX.Element => (
  <ReactMarkdown components={{ ...defaultComponents, ...(components ?? {}) }} {...others} />
);
